import styled from "styled-components";
import { Tab } from "react-bootstrap";
import { } from "../../../constants";

export const TabContainer = styled(Tab.Container)`
  width:100%
`;
